/**
 * Access Denied Page
 */
import { useNavigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

const AccessDeniedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center max-w-md p-8">
        <div className="mx-auto h-16 w-16 text-red-500 mb-4">
          <ShieldAlert size={64} />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
        <p className="text-gray-600 mb-6">You do not have permission to access this page.</p>
        <button
          onClick={() => navigate('/dashboard', { replace: true })}
          className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
